import { iconStatusError, iconStatusInfo, iconStatusSuccess, iconStatusWarning, } from '@tesla/design-system-icons';
import cx from 'classnames';
import React from 'react';
import { Icon } from '../icon/icon.js';
const iconStatusMap = {
    error: React.createElement(Icon, { data: iconStatusError }),
    info: React.createElement(Icon, { data: iconStatusInfo }),
    success: React.createElement(Icon, { data: iconStatusSuccess }),
    warning: React.createElement(Icon, { data: iconStatusWarning }),
};
export const StatusMessage = ({ body, className, enclosed = true, header, type, ...rest }) => {
    const typeIcon = type ? iconStatusMap[type] : null;
    return (React.createElement("div", { className: cx('tds-status_msg', {
            'tds-card tds-card--dense': enclosed,
        }, className), role: "status", ...rest },
        typeIcon,
        React.createElement("div", { className: "tds-card-body" },
            header && React.createElement("div", { className: "tds-text--h6" }, header),
            body && React.createElement("div", null, body))));
};
